import React from "react";
import { useNavigate } from "react-router-dom";
import { Img } from "components";
import Logo from "Assests/Images/LogoMain.png";

const Header = () => {
  const navigate = useNavigate();

  return (
    <header className="absolute top-0 left-0 right-0 z-50 flex items-center justify-between px-4 py-4 md:px-8">
      <div>
        <div
          onClick={() => navigate("/")}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 5,
            cursor: "pointer",
          }}
        >
          <Img
            src={Logo}
            alt="Sidebar Logo"
            className="h-[2rem] w-auto object-contain md:h-[2.25rem]"
          />
          
        </div>
      </div>
      <nav>
        <ul className="flex list-none m-0 p-0 gap-5">
          <li>
            {/* <button
              type="button"
              onClick={() => navigate("/signup")}
              className="hero-signup-btn min-w-[96px] px-5 py-1.5 text-[12px] bg-white text-black rounded-full font-semibold shadow-sm md:text-[14px]"
            >
              Sign Up
            </button> */}
            <button onClick={() => navigate("/signup")} className="signup-btn" style={{fontWeight: 400,fontFamily: 'Inter var',}}>Sign Up</button>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
